import mitt from 'mitt';

const bus = mitt()

bus.on('*', (type,e) => {
    console.log("bus called", type, e)
    console.table({"Event Name":type, Value:e})
})

window.bus = bus

export default bus